// extracted by mini-css-extract-plugin
export default {"item":"RoleList_item_2g-FY"};